import BaseService from '@/services/BaseService'
import {http} from './config'

class LancamentoCaixaService extends BaseService {
    constructor(){
        super('/v1/lancamentos-caixa')
    }

    listar(data){
        // const queryParams = `
        //     id=${data.id ? data.id : ''}
        //     &tipo=${data.tipo ? data.tipo : ''}
        //     &funcionarioId=${data.funcionarioId ? data.funcionarioId : ''}
        //     &data=${data.data ? data.data : ''}
        //     &page=${data.page ? data.page : 1}
        //     &limit=${data.limit ? data.limit : 20}
            // `
        return http.get(`/v1/lancamentos-caixa`, {params: data})
    }

    relatorioFechamentoCaixa(data){
        // const queryParams = `
        // &funcionario_id=${data.funcionario_id ? data.funcionario_id : ''}
        // &periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ''}
        // &modelo_impressao=${data.modelo_impressao ? data.modelo_impressao : ''}`
        return http.get(`/v1/fechamento-caixa-relatorio`, {params: data})
    }

    imprimirLancamento(id){
        return http.get(`/v1/lancamento-caixa/${id}/imprimir`)
    }
}

export default new LancamentoCaixaService